import { rc } from "./rc";

export const employee_voice_company_personality = {
  rc,
};
